// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2F7sk","signatureButtonsRight":"ModalSign_signatureButtonsRight__1lNlt"};